import { AnalyticsBarRow } from "../../../common/components/analytics-component/bar-list/AnalyticsBars";
import { AnalyticsHeatmapRow } from "../../../common/components/analytics-component/heatmap/AnalyticsHeatmap";
import { VendRetentionCohort } from "../../../model/bps-admin/business-analytics";

/** Stand-in split of how dormant customers came back. */
export const REACTIVATION_SOURCES: AnalyticsBarRow[] = [
	{ label: "Reminder push", percent: 64, trailing: "64%" },
	{ label: "Organic return", percent: 26, trailing: "26%" },
	{ label: "Referral / other", percent: 10, trailing: "10%" },
];

/**
 * The overview and the retention page both draw the vend-retention grid, so its
 * columns and its rows are built here once — two copies would let the same figure
 * differ between them.
 *
 * null is a week the cohort has not reached yet, which is why the grids are
 * triangular — and it is not the same as a zero, which is why the heatmap draws it
 * off the colour ramp.
 */
export const RETENTION_COLUMNS = ["W0", "W1", "W2", "W3", "W4", "W5", "W6"];

// "2026-09-07" -> "Sep 7", the design's label. Built from the date parts in local time:
// new Date("2026-09-07") would read it as UTC midnight and land a day early west of it.
const weekLabel = (weekStart: string) => {
	const [year, month, date] = weekStart.split("-").map(Number);
	return new Date(year, month - 1, date).toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

/** The vend-retention response as heatmap rows, one per cohort week. */
export const vendRetentionRows = (cohorts: VendRetentionCohort[] = []): AnalyticsHeatmapRow[] =>
	cohorts.map(cohort => ({ label: weekLabel(cohort.weekStart), values: cohort.weeks }));

// The two stand-in grids below back the first-vend / payment-vend switch, which is
// commented out in RetentionSection: the endpoint has one cohort definition, so there
// is nothing to switch between yet.

/** Cohorts keyed on the week a user first vended at all. */
export const FIRST_VEND_COHORTS: AnalyticsHeatmapRow[] = [
	{ label: "Jun 2", values: [100, 54, 41, 33, 28, 24, 21] },
	{ label: "Jun 9", values: [100, 51, 39, 31, 26, 22, 19] },
	{ label: "Jun 16", values: [100, 56, 43, 35, 29, 25, null] },
	{ label: "Jun 23", values: [100, 49, 37, 30, 25, null, null] },
	{ label: "Jun 30", values: [100, 58, 44, 36, null, null, null] },
];

/**
 * Stand-in feature comparison: the same weeks for users who switched auto-recharge on
 * against those who did not. The baseline is the series the chart draws muted.
 */
export const AUTO_RECHARGE_ADOPTERS = [100, 78, 68, 60, 55, 50, 46];

export const AUTO_RECHARGE_NON_ADOPTERS = [100, 62, 48, 38, 31, 26, 22];

/** The same weeks, but only users who completed a paid vend — a deeper first step, so it holds better. */
export const PAYMENT_VEND_COHORTS: AnalyticsHeatmapRow[] = [
	{ label: "Jun 2", values: [100, 67, 55, 47, 41, 36, 33] },
	{ label: "Jun 9", values: [100, 64, 52, 44, 38, 34, 30] },
	{ label: "Jun 16", values: [100, 69, 57, 49, 43, 38, null] },
	{ label: "Jun 23", values: [100, 62, 50, 43, 37, null, null] },
	{ label: "Jun 30", values: [100, 71, 59, 51, null, null, null] },
];
